<template>
    <div ref="consumerInsightPieChart" style="width: 100%; height: 300px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    am4core.useTheme(am4themes_animated);

    export default {
        data () {
            return {
                chart : null,
                label : null,
                colors : ['#83A2FF', '#FF83A2', '#83FFE0', '#FFE083', '#C8FFA3', '#DABAFF'],

                dummyData : [
                    {datafield:"Helm", count:21000},
                    {datafield:"Jok", count:19000},
                    {datafield:"Spion", count:17000},
                    {datafield:"Busi", count:25000},
                    {datafield:"Tutup Bensin", count:25000},
                    {datafield:"Muffle Protector", count:25000},
                ]
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                let length = this.chart.data.length;

                let total = 0
                let topCount = 0
                let topLabel = ""
                let data = this.data && this.data.length > 0 ? this.data.map((x, i)=>{
                    total += x.count
                    if (x.count > topCount) {
                        topCount = x.count
                        topLabel = x.datafield
                    }
                    return {
                        datafield : x.datafield,
                        count : x.count,
                        color : this.colors[i%this.colors.length]
                }}) : [{
                    datafield: 'No Data',
                    count: 1,
                    color: '#83A2FF'
                }];
                
                this.label.text = topCount + '\n' + topLabel

                this.chart.addData(data, length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.consumerInsightPieChart, am4charts.PieChart);

                this.chart.colors.list = [
                    am4core.color("#80F2AC"),
                    am4core.color("#F2809F"),
                    am4core.color("#80B2F0"),
                    am4core.color("#F2BC80"),
                    am4core.color("#F099F7"),
                    am4core.color("#ACF9FF"),
                ]

                // Add and configure Series
                let pieSeries = this.chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "count";
                pieSeries.dataFields.category = "datafield";

                // Let's cut a hole in our Pie chart the size of 55% the radius
                this.chart.innerRadius = am4core.percent(50);

                // Put a thick white border around each Slice
                pieSeries.slices.template.stroke = am4core.color("#fff");
                pieSeries.slices.template.strokeWidth = 2;
                pieSeries.slices.template.strokeOpacity = 1;
                pieSeries.slices.template
                // change the cursor on hover to make it apparent the object can be interacted with
                .cursorOverStyle = [
                    {
                    "property": "cursor",
                    "value": "pointer"
                    }
                ];

                pieSeries.slices.template.adapter.add("fill", (fill, target)=>{
                    return this.chart.colors.getIndex(target.dataItem.index);
                })

                pieSeries.alignLabels = false;
                // pieSeries.labels.template.bent = true;
                // pieSeries.labels.template.radius = 3;
                // pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.ticks.template.disabled = true;
                pieSeries.alignLabels = false;
                pieSeries.labels.template.text = ''; // "[bold]{value.percent.formatNumber('#.0')}%";
                pieSeries.labels.template.bent = true;
                pieSeries.labels.template.radius = am4core.percent(-25);
                pieSeries.labels.template.fill = am4core.color("#FFF");
                pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.labels.template.adapter.add("radius", (radius, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.percent(2.5);
                    } 
                    return radius;
                })

                pieSeries.labels.template.adapter.add("fill", (color, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.color("#000");
                    } 
                    return color;
                })

                // Create a base filter effect (as if it's not there) for the hover to return to
                let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
                shadow.opacity = 0;

                // Create hover state
                let hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

                // Slightly shift the shadow and make it more prominent on hover
                let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
                hoverShadow.opacity = 0.7;
                hoverShadow.blur = 5;

                // Add a legend
                this.chart.legend = new am4charts.Legend();
                this.chart.legend.useDefaultMarker = true;
                this.chart.legend.maxHeight = 100;
                this.chart.legend.scrollable = true;
                this.chart.contentWidth = 2000;
                var marker = this.chart.legend.markers.template;
                // marker.cornerRadius(12, 12, 12, 12);
                marker.width = 5;
                marker.height = 20;


                // Add label
                // this.chart.innerRadius = 100;
                this.label = this.chart.seriesContainer.createChild(am4core.Label);
                this.label.text = "No Data";
                this.label.horizontalCenter = "middle";
                this.label.verticalCenter = "middle";
                this.label.textAlign = "middle";
                this.label.fontSize = 14;

                // let label2 = this.chart.seriesContainer.createChild(am4core.label);
                // label.text = "2000";
                // label.horizontalCenter = "middle";
                // label.verticalCenter = "bottom";
                // label.fontSize = 30;
            }   
        }
    }
</script>

<style scoped>

</style>